import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ResBodyType } from 'otimus-shared'
import { ServerUrlService } from './server-url.service'
import { SystemHelpMessageType, SystemVersionType } from '../interfaces/system-info'

@Injectable({ providedIn: 'root' })
export class SystemInfoService {
  constructor(
    private http: HttpClient,
    private serverUrl: ServerUrlService
  ) {}

  findSystemVersion(): Observable<ResBodyType<SystemVersionType>> {
    return this.http.get<ResBodyType<SystemVersionType>>(
      `${this.serverUrl.url}/system/info/system-version`
    )
  }

  findSystemHelpMessage(): Observable<ResBodyType<SystemHelpMessageType>> {
    return this.http.get<ResBodyType<SystemHelpMessageType>>(
      `${this.serverUrl.url}/system/info/system-help-message`
    )
  }
}
